/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Schedule_AnchorInputs */

const cs_automation_schedule_anchor = /** @type {(inputs: Automation_Schedule_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotevní pole`)
};

const en_automation_schedule_anchor = /** @type {(inputs: Automation_Schedule_AnchorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anchor field`)
};

/**
* | output |
* | --- |
* | "Anchor field" |
*
* @param {Automation_Schedule_AnchorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_schedule_anchor = /** @type {((inputs?: Automation_Schedule_AnchorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Schedule_AnchorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_schedule_anchor(inputs)
	return cs_automation_schedule_anchor(inputs)
});